import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { IconsEnum, IconSize } from '@/shared/enums';
import { NgStyle } from '@angular/common';
import { Icon } from '../icon/icon';

@Component({
  selector: 'bevvi-text-input',
  imports: [NgStyle, Icon],
  templateUrl: './text-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInput {
  private readonly inputEl = viewChild<ElementRef<HTMLInputElement>>('inputEl');

  public readonly value = input<string>('');
  public readonly placeholder = input('Enter your message');
  public readonly disabled = input(false);
  public readonly readonly = input(false);
  public readonly fullWidth = input(true);
  public readonly backgroundColor = input('#F4F4F4');
  public readonly borderColor = input('#B7C6D2');
  public readonly focusBorderColor = input('var(--bot-primary, #C93030)');
  public readonly textColor = input('#1A1A1A');
  public readonly placeholderColor = input('#7B7B7B');
  public readonly actionIcon = input<IconsEnum>(IconsEnum.SEND);

  public readonly valueChange = output<string>();
  public readonly actionClick = output<void>();

  protected readonly iconSize = IconSize;

  protected readonly inputStyles = computed(() => ({
    '--input-bg': this.backgroundColor(),
    '--input-border': this.borderColor(),
    '--input-focus-border': this.focusBorderColor(),
    '--input-text': this.textColor(),
    '--input-placeholder': this.placeholderColor(),
  }));

  public onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;

    this.valueChange.emit(value);
  }

  constructor() {
    afterRenderEffect(() => {
      if (this.disabled()) return;
      this.inputEl()?.nativeElement.focus();
    });
  }
}
